import { Search } from '@mui/icons-material'
import { InputAdornment } from '@mui/material'
import React from 'react'
export default function SearchStartAdornment() {
  return (
    <InputAdornment position="start">
      <Search color="white" />
    </InputAdornment>
  )
}
